import { apisStore } from "context/GlobalStates";
import { useEffect, useState } from "react";
import Apis from "serviceapi/ApiImports";
import { DatasetDataInfoResponse } from "axios/apiModels";
import AllDatasetsList from "./AllDatasetsList";
import SelectedDatasetsList from "./SelectedDatasetsList";
import { ApiConfig, Pages } from "../../axios/Config";
import NotificationPopUp from "util/NotificationPopUp";

import "./DatasetsPage.scss";
import {
  DatasetInfo,
  EASASDatasetsApi,
} from "../../serviceapi/dataCollectorApi";
import { EasasDatasetsApi } from "../../serviceapi/jobRunnerApi";

const DatasetsPage = () => {
  const [datasetsList, setDatasetsList] = useState<DatasetInfo[]>([]);
  const [selectedDatasets, setSelectedDatasets] = useState<DatasetInfo[]>([]);
  const [datasetsListWithInfo, setDatasetsListWithInfo] = useState<
    DatasetDataInfoResponse[]
  >([]);
  const [apiDatasetsDC, setApiDatasetsDC] = useState<EASASDatasetsApi | null>(
    null
  );

  const [apiDatasetsJR, setApiDatasetsJR] = useState<EasasDatasetsApi | null>(
    null
  );

  useEffect(() => {
    const fetchData = async () => {
      const jobRunnerVersion = await getJobRunnerVersion();

      if (jobRunnerVersion) {
        ApiConfig.setBaseUrl(Pages.JOB_RUNNER);
        Apis("jobrunner");
        setApiDatasetsJR(apisStore.getState()?.jobRunner.datasetsApi || null);
      } else {
        ApiConfig.setBaseUrl(Pages.DATA_COLLECTOR);
        Apis("datacollector");
        setApiDatasetsDC(
          apisStore.getState()?.dataCollector?.datasetsApiDC || null
        );
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (apiDatasetsDC) {
      fetchListOfDatasetsDC();
    }
    if (apiDatasetsJR) {
      fetchListOfDatasetsJR();
    }
  }, [apiDatasetsDC, apiDatasetsJR]);

  const apiDatasetsData = apisStore.getState()?.dataCollector?.datasetDataApi;
  const apiJobrunnerVersion = apisStore.getState()?.jobRunner?.versionApiJR;

  const getJobRunnerVersion = async () => {
    if (!apiJobrunnerVersion) {
      console.error("apiJobrunnerVersion is undefined, cannot fetch version.");
      return false;
    }
    try {
      const response = await apiJobrunnerVersion.getVersion();

      return !!response.data;
    } catch (error) {
      console.error("Error fetching version:", error);
      return false;
    }
  };

  const fetchListOfDatasetsJR = async () => {
    if (!apiDatasetsJR) {
      NotificationPopUp.show("Failed to fetch datasets.", "error");
      console.error("apiDatasets is undefined, cannot fetch datasets.");
      return;
    }

    try {
      const response = await apiDatasetsJR.queryDatasets(true);
      setDatasetsList(response.data as DatasetInfo[]);
    } catch (error) {
      NotificationPopUp.show("Failed to fetch datasets.", "error");
      console.error("Error fetching datasets:", error);
    }
  };

  const fetchListOfDatasetsDC = async () => {
    if (!apiDatasetsDC) {
      NotificationPopUp.show("Failed to fetch datasets.", "error");
      console.error("apiDatasetsDC is undefined, cannot fetch datasets.");
      return;
    }
    try {
      const response = await apiDatasetsDC.searchDatasets(true);
      setDatasetsList(response?.data as DatasetInfo[]);
    } catch (error) {
      NotificationPopUp.show("Failed to fetch datasets.", "error");
      console.error("Error fetching datasets:", error);
    }
  };

  const fetchDatasetsInfoRecentJR = async (selectedDatasets: DatasetInfo[]) => {
    const arrayOfIdentifiers = selectedDatasets.map(
      (dataset) => dataset.identifier
    );
    if (!selectedDatasets || !apiDatasetsJR) return;
    try {
      const response = await apiDatasetsJR.getDataInfoRecent(
        arrayOfIdentifiers as string[]
      );
      setDatasetsListWithInfo(response.data as DatasetDataInfoResponse[]);
    } catch (error) {
      NotificationPopUp.show("Failed to fetch datasets info.", "error");
      console.error("Error fetching datasets:", error);
    }
  };

  const fetchDatasetsInfoRecentDC = async (selectedDatasets: DatasetInfo[]) => {
    const arrayOfIdentifiers = selectedDatasets.map(
      (dataset) => dataset.identifier
    );
    if (!selectedDatasets || !apiDatasetsDC) return;
    try {
      const response = await apiDatasetsData?.getDatasetDataInfoRecent(
        arrayOfIdentifiers as string[],
        undefined,
        undefined,
        false
      );

      setDatasetsListWithInfo(
        (response.data as DatasetDataInfoResponse[]) || []
      );
    } catch (error) {
      NotificationPopUp.show("Failed to fetch datasets info.", "error");
      console.error("Error fetching datasets:", error);
    }
  };

  const handleUnselectAllDatasets = () => {
    setSelectedDatasets([]);
    setDatasetsListWithInfo([]);
  };

  const handleUnselectDataset = (identifier: String) => {
    const updatedSelectedDatasets = selectedDatasets.filter(
      (dataset: DatasetInfo) => dataset.identifier !== identifier
    );
    setSelectedDatasets(updatedSelectedDatasets);
    if (apiDatasetsDC) {
      fetchDatasetsInfoRecentDC(updatedSelectedDatasets);
    } else {
      fetchDatasetsInfoRecentJR(updatedSelectedDatasets);
    }
  };

  return (
    <div className="flex flex-row datasets-page">
      <AllDatasetsList
        datasetsList={datasetsList}
        fetchDatasetsInfoRecent={
          apiDatasetsDC ? fetchDatasetsInfoRecentDC : fetchDatasetsInfoRecentJR
        }
        selectedDatasets={selectedDatasets}
        setSelectedDatasets={setSelectedDatasets}
      />
      <SelectedDatasetsList
        datasetsListWithInfo={datasetsListWithInfo}
        handleUnselectAllDatasets={handleUnselectAllDatasets}
        handleUnselectDataset={handleUnselectDataset}
      />
    </div>
  );
};

export default DatasetsPage;
